module.exports = __webpack_public_path__ + "static/img/banner_02.96e5f43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/es/banner_02.png
// module id = gG5E
// module chunks = 0